import { createSelector } from "reselect"
import { find, last, first } from "lodash"
import { computeData } from "modules/analyze-forecast/selectors/data"
import { getAllCategoryItems } from "modules/analyze-forecast/selectors/items"
import { getForecast } from "modules/analyze-forecast/selectors/forecast"
import { DATABASE_DATE_FORMAT } from "helpers/formatters/dates"

const getSelectedDate = (_, props) => props.selectedDate
const getSelectedRaw = state => state.modules.analyzeForecastDetails.selected

const getContributorData = createSelector(
  [getAllCategoryItems, getForecast],
  (items, forecast) => computeData(items, forecast),
)

const getLastContributor = createSelector(
  [getContributorData],
  (data) => last(data),
)

// This is jump straight to the contributors drilldown
export const getSelected = createSelector(
  [getSelectedRaw, getAllCategoryItems],
  (selected, items) => first(items),
)

export const getDetails = createSelector(
  [getContributorData, getSelectedDate, getAllCategoryItems, getLastContributor],
  (data, date, items, lastContributor) => {
    let dayData = {}

    if (lastContributor) {
      if (date === lastContributor.date.format(DATABASE_DATE_FORMAT)) {
        dayData = lastContributor
      } else {
        const contributor = find(data, day => date === day.date.format(DATABASE_DATE_FORMAT))
        if (contributor) {
          dayData = contributor
        }
      }
    }

    return items
      .map(item => ({
        label: item.label,
        id: item.id,
        value: dayData[item.id],
        color: item.color,
        category: item.category,
        favorite: item.favorite,
        field: item.field,
      }))
      .filter(item => item.value || item.favorite)
  },
)

export const getSelectedValue = createSelector(
  [getDetails, getSelected],
  (contributors, selected) => {
    if (!selected) {
      return 0
    }

    const item = find(contributors, d => d.id === selected.id)
    if (item) {
      return item.value
    }
    return 0
  },
)
